// src/components/Header/Header.tsx (VERSÃO CORRIGIDA)

import React from 'react';
import TopNav from '../TopNav/TopNav';
import styles from './Header.module.css';
import { useAuth } from '../../context/AuthContext'; // 1. IMPORTAR O HOOK

interface HeaderProps {
  title: string;
  onCartClick: () => void;
  onAccountClick: () => void;
  // A prop 'loggedInUserRole' foi REMOVIDA daqui, pois não é mais necessária
}

const Header: React.FC<HeaderProps> = ({ title, onCartClick, onAccountClick }) => {
  // 2. USAR O CONTEXTO PARA OBTER O ESTADO DE LOGIN
  const { user } = useAuth();
  
  // Deriva o 'role' a partir do objeto 'user'
  const loggedInUserRole = user ? (user.role as 'user' | 'admin') : 'guest';

  return (
    <header className={styles.sectionHeader}>
      <div className={styles.titleContainer}>
        <h1 className={styles.mainTitle}>{title}</h1>
      </div>
      <TopNav 
        onCartClick={onCartClick} 
        onAccountClick={onAccountClick} 
        loggedInUserRole={loggedInUserRole} // O TopNav continua recebendo a prop normalmente
      />
    </header>
  );
};

export default Header;